import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

export type DoffinNoAnswer = "nothingSent" | "whileSending";

const NO_ANSWER_CODES: Record<string, DoffinNoAnswer> = {
  zz_DoffinApiErrorCode_DoffinDidNotAnswerNothingSent: "nothingSent",
  zz_DoffinApiErrorCode_DoffinDidNotAnswerWhileSending: "whileSending",
};

const GATEWAY_GAVE_UP = new Set([502, 503, 504]);

const NO_RESPONSE = new Set(["FETCH_ERROR", "TIMEOUT_ERROR"]);

const statusOf = (e: unknown): unknown => (typeof e === "object" && e !== null ? (e as { status?: unknown }).status : undefined);

export const doffinNoAnswer = (e: unknown): DoffinNoAnswer | null => {
  if (NO_RESPONSE.has(statusOf(e) as string)) return "whileSending";
  if (!isFetchBaseQueryError(e)) return null;
  if (isApiErrorDto(e.data)) return NO_ANSWER_CODES[e.data.errorCode] ?? null;
  const status = e.status === "PARSING_ERROR" ? e.originalStatus : e.status;
  return typeof status === "number" && GATEWAY_GAVE_UP.has(status) ? "whileSending" : null;
};
